module.exports = __webpack_public_path__ + "static/media/back-chevron-brand-refresh.09d7072a.svg";